import { toast } from "react-toastify";
import { subscribe } from "../../API/functions";
import { useMutation } from "@tanstack/react-query";

export const useSubscription = () => {
  const { mutate ,isPending} = useMutation({
    mutationFn: (email) => subscribe(email),
    onSuccess: (data) => {
      toast.success(data.message);
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { mutate,isPending };
};